import { Icon } from '@iconify/react'
import type { MenuItemType } from 'antd/es/menu/interface'
import { PATH_SEGMENT } from 'routes/pathSegments'
import { iconStyle } from './components/MenuWidget/MenuWidget'

const getIcon = (iconName: string) => <Icon icon={iconName} style={iconStyle} />

const showForCustomer = <T,>(isStaff: boolean, item: T): T | null => {
  return isStaff ? null : item
}

type MenuItem = MenuItemType & {
  children?: MenuItem[]
}

const config = {
  getNavigableKeys: (isStaff: boolean, hasEmrEnabled: boolean): string[] => {
    const menus = config.getMenus(isStaff, hasEmrEnabled)
    const navigableKeys: string[] = []

    const extractLeafKeys = (items: MenuItem[]): void => {
      items.forEach((item) => {
        if (item && typeof item === 'object' && 'key' in item) {
          if (item.children && Array.isArray(item.children)) {
            extractLeafKeys(item.children as MenuItem[])
          } else {
            navigableKeys.push(String(item.key))
          }
        }
      })
    }

    extractLeafKeys(menus)
    return navigableKeys
  },

  getMenus: (isStaff: boolean, hasEmrEnabled: boolean) =>
    [
      {
        key: 'account',
        label: 'My Account',
        icon: getIcon('ant-design:user-outlined'),
        children: [
          {
            key: PATH_SEGMENT.PERSONAL_PROFILE,
            label: 'Personal',
          },
          {
            key: PATH_SEGMENT.PREFERENCES,
            label: 'Preferences',
          },
          {
            key: PATH_SEGMENT.CHANGE_PASSWORD,
            label: 'Change Password',
          },
        ].filter(Boolean),
      },

      showForCustomer(isStaff, {
        key: PATH_SEGMENT.CREDIT_CARDS,
        label: 'Credit Cards',
        icon: getIcon('ph:credit-card-duotone'),
      }),

      showForCustomer(isStaff, {
        key: 'finance',
        label: 'Finance',
        icon: getIcon('ant-design:dollar-twotone'),
        children: [
          {
            key: PATH_SEGMENT.BILLING_HISTORY,
            label: 'Billing History',
          },
          {
            key: PATH_SEGMENT.PAYMENTS_HISTORY,
            label: 'Payments History',
          },
          {
            key: PATH_SEGMENT.DEPOSIT,
            label: 'Deposit',
          },
        ],
      }),
      hasEmrEnabled
        ? {
            key: 'transactions',
            label: 'Transactions',
            icon: getIcon('ph:credit-card-duotone'),
            children: [
              {
                key: PATH_SEGMENT.TRANSACTIONS_HISTORY,
                label: 'History',
              },
              {
                key: PATH_SEGMENT.TRANSACTIONS_MAPPING,
                label: 'Mapping',
              },
            ],
          }
        : null,
      hasEmrEnabled
        ? {
            key: 'patient-data',
            label: 'Patient Data',
            icon: getIcon('ic:twotone-medication'),
            children: [
              {
                key: PATH_SEGMENT.PRESCRIPTIONS,
                label: 'Prescriptions',
              },
              // {
              //   key: PATH_SEGMENT.TEST_RESULTS,
              //   label: 'Test Results',
              // },
            ],
          }
        : null,
      showForCustomer(isStaff, {
        key: PATH_SEGMENT.MEDIA_PREFERENCES,
        label: 'Media Preferences',
        icon: getIcon('solar:tv-line-duotone'),
      }),
      showForCustomer(isStaff, {
        key: PATH_SEGMENT.MAILBOX_PROFILE,
        label: 'Mailbox Profile',
        icon: getIcon('solar:mailbox-bold-duotone'),
      }),
      {
        key: PATH_SEGMENT.COMPLETED_BOOKINGS,
        label: 'Completed Bookings',
        icon: getIcon('ph:book-duotone'),
      },
    ].filter(Boolean),
}

export type ProfileMenuConfigType = typeof config

export const profileMenuConfig: ProfileMenuConfigType = Object.freeze(config)
